export function amountFormat(number) {
  if (number === null || number === "" || number === undefined) {
    return "";
  } else {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
